/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    initialQueryState, Links,
    PaginationState,
    QUERIES,
    stringifyRequestQuery,
    WithChildren,
} from '../../../../../_metronic/helpers'
import {useQueryRequest} from '../../shared/list/core/QueryRequestProvider'
import {Request} from '../../../../shared/models/_models'
import {getRequest} from '../../../../shared/services/request-service'
import {useLocation} from "react-router-dom";

let pagination: { _meta: any; data?: Request[] | undefined; payload?: { message?: string | undefined; errors?: { [key: string]: string[] } | undefined; pagination?: PaginationState | undefined } | undefined; _links?: Links };

const QueryResponseContext = createResponseContext<Request>(initialQueryResponse)
const QueryResponseProviderRequests: FC<WithChildren> = ({children}) => {
    const location = useLocation()
    const {state} = useQueryRequest()
    const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
    const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

    useEffect(() => {
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        `${QUERIES.REQUEST_LIST}-${query}`,
        () => {
            if(location.pathname.startsWith('/request')) {
                return getRequest(`${query}&expand=user.immediate_superiors`)
            } else {
                return getRequest(`${query}&team_leader=true&expand=user.immediate_superiors`)
            }
        },
        {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
    )

    return (
        <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
            {children}
        </QueryResponseContext.Provider>
    )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
    const {response} = useQueryResponse()
    if (!response) {
        return []
    }

    pagination = response;
    return response?.data || []
}

const useQueryResponsePagination = () => {
    const defaultPaginationState: PaginationState = {
        links: [
            {
                label: '<',
                active: false,
                url: 'http://api.veritas.local/v1/request?page=' + (pagination?._meta?.currentPage - 1),
                page: pagination?._meta?.currentPage - 1,
            },
            {
                label: (pagination?._meta?.currentPage - 1) ? (pagination?._meta?.currentPage - 1) : '0',
                active: false,
                url: 'http://api.veritas.local/v1/request?page=' + (pagination?._meta?.currentPage - 1),
                page: pagination?._meta?.currentPage - 1,
            },
            {
                label: (pagination?._meta?.currentPage) ? (pagination?._meta?.currentPage) : '1',
                active: true,
                url: 'http://api.veritas.local/v1/request?page=' + pagination?._meta?.currentPage,
                page: pagination?._meta?.currentPage,
            },
            {
                label: (pagination?._meta?.currentPage + 1) ? (pagination?._meta?.currentPage + 1) : '2',
                active: false,
                url: 'http://api.veritas.local/v1/request?page=' + (pagination?._meta?.currentPage + 1),
                page: pagination?._meta?.currentPage + 1,
            },
            {
                label: '>',
                active: false,
                url: 'http://api.veritas.local/v1/request?page=' + (pagination?._meta?.currentPage + 1),
                page: pagination?._meta?.currentPage + 1,
            },
        ],
        ...initialQueryState,
    }

    const {response} = useQueryResponse()

    if (!response || !response.payload || !response.payload.pagination) {
        return {
            items_per_page: response?._meta.perPage,
            links: response?._meta?.totalCount !== 0 ? defaultPaginationState.links : [],
            page: response?._meta.currentPage,
            total_pages: response?._meta.totalCount
        }
    }

    return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
    const {isLoading} = useQueryResponse()
    return isLoading
}

export {
    QueryResponseProviderRequests,
    useQueryResponse,
    useQueryResponseData,
    useQueryResponsePagination,
    useQueryResponseLoading,
}
